import React from 'react';
import { Clearfix } from 'react-bootstrap';

import LeadTimelineContent from 'components/layout/lead/LeadTimelineContent';

export default class LeadTimeline extends React.Component {
  render() {
    const { entity, entityLoaded } = this.props;

    return entityLoaded ? (
      <Clearfix>
        <LeadTimelineContent entity={entity} />
      </Clearfix>
    ) : null;
  }
}
